import(/* webpackMode: "eager", webpackExports: ["CohesionContext","CohesionProvider","useMonarch","useMonarchRule","useMonarchRequest","useMonarchSlot","useMonarchSlotContext","MonarchSlotContext","MonarchSlot"] */ "/workspace/node_modules/@redventures/cohesion-utils-react/dist/CohesionProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/globals.css");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/[locale]/recaptcha.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@highereducation/supersonic-ui/dist/index.css");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/@highereducation/hen-ui/dist/index.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/components/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BranchIOInitializer"] */ "/workspace/src/components/ClientBranchIO/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientOnly"] */ "/workspace/src/components/Cohesion/ClientOnly.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/Cohesion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CohesionReady"] */ "/workspace/src/components/CohesionReady/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/Navigation/AbandonedCartTest/WelcomeBackModal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/Navigation/multiCart/AddToCartModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/Navigation/multiCart/WelcomeBackModal/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthModalProvider"] */ "/workspace/src/contexts/AuthModalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/workspace/src/contexts/CartProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/workspace/src/contexts/ModalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultitenantConfigProvider"] */ "/workspace/src/contexts/MultitenantConfigContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserPreferencesProvider"] */ "/workspace/src/contexts/UserPreferencesContext/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/monarch/MonarchResolver.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MonarchRuleProvider"] */ "/workspace/src/monarch/rules/MonarchRulesProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebviewProvider"] */ "/workspace/src/webview/WebviewContext.tsx");
